import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import ReactSelect, {components} from 'react-select';
import cn from 'classnames';

import stylesModule from './Select.module.scss';

export const Select = ({
  multiple,
  options,
  placeholder,
  className,
  loading,
  value,
  isSearchable,
  styles,
  controlAmountText,
  GroupHeading,
  onChange,
}) => {
  const [val, setVal] = useState([]);

  const handleChange = values => {
    setVal(values);
    if (onChange) onChange(values);
  };

  if (options[0] && typeof options[0] === 'string') {
    options = options.map(item => ({value: item, label: item}));
  }

  const DefaultGroupHeading = props => <components.GroupHeading {...props} />;

  const num = val.length;
  const bigNum = num > 1;

  useEffect(() => {
    if (value && value[0] && typeof value[0] === 'string') {
      const newValue = value.map(item => ({value: item, label: item}));
      setVal(newValue);
    } else {
      setVal(value);
    }
  }, [value]);

  return (
    <div
      className={cn(stylesModule.wrap, className, {
        [stylesModule.hiddenValues]: bigNum,
      })}
    >
      <div className={stylesModule.infoText}>
        {num} {controlAmountText}
      </div>

      <ReactSelect
        classNamePrefix="Select"
        value={val}
        closeMenuOnSelect={false}
        isLoading={loading}
        placeholder={placeholder}
        className={stylesModule.select}
        name="color"
        options={options}
        isMulti={multiple}
        isSearchable={isSearchable}
        isClearable={false}
        cropWithEllipsis={false}
        hideSelectedOptions={false}
        styles={styles}
        components={{GroupHeading: GroupHeading || DefaultGroupHeading}}
        onChange={handleChange}
      />
    </div>
  );
};

Select.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  ),
  multiple: PropTypes.bool,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  loading: PropTypes.bool,
  value: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  ).isRequired,
  isSearchable: PropTypes.bool,
  styles: PropTypes.object,
  controlAmountText: PropTypes.string,
  GroupHeading: PropTypes.func,
  onChange: PropTypes.func,
};

Select.defaultProps = {
  multiple: false,
  options: [],
  placeholder: 'Select...',
  className: null,
  loading: false,
  isSearchable: false,
  styles: {},
  controlAmountText: 'items',
  GroupHeading: () => null,
  onChange: () => null,
};
